import { api } from '../lib/api';
import type { ShareFolder } from '../types';

export interface ShareHistoryEntry {
  id: string;
  resourceId: string;
  resourceType: string;
  recipientEmail: string;
  sharedAt: string;
  contactId: string | null;
  contactName: string | null;
  contactPhoto: string | null;
  folderId: string | null;
  item: {
    title: string | null;
    type: string | null;
    imageUrl: string | null;
    content: string | null;
  } | null;
}

export interface SharedWithMeEntry {
  id: string;
  type: string;
  title: string | null;
  content: string | null;
  summary: string | null;
  imageUrl: string | null;
  site: string | null;
  createdBy: string;
  createdAt: string;
  sharedAt: string;
  senderName: string | null;
  senderEmail: string | null;
  tags: string[];
  autoTags: string[];
}

export async function getSharedByMe(opts?: { folderId?: string; ungrouped?: boolean }): Promise<ShareHistoryEntry[]> {
  const q = new URLSearchParams();
  if (opts?.folderId) q.set('folderId', opts.folderId);
  if (opts?.ungrouped) q.set('ungrouped', 'true');
  const qs = q.toString() ? `?${q}` : '';
  return api<ShareHistoryEntry[]>(`/api/shared/by-me${qs}`);
}

export async function getSharedWithMe(): Promise<SharedWithMeEntry[]> {
  return api<SharedWithMeEntry[]>('/api/shared/with-me');
}

export async function moveShareToFolder(shareId: string, folderId: string | null): Promise<void> {
  await api(`/api/shared/by-me/${shareId}/folder`, { method: 'PATCH', body: JSON.stringify({ folderId }) });
}

export async function getShareFolders(): Promise<ShareFolder[]> {
  return api<ShareFolder[]>('/api/share-folders');
}

export async function createShareFolder(name: string): Promise<ShareFolder> {
  return api<ShareFolder>('/api/share-folders', { method: 'POST', body: JSON.stringify({ name }) });
}

export async function updateShareFolder(id: string, name: string): Promise<void> {
  await api(`/api/share-folders/${id}`, { method: 'PATCH', body: JSON.stringify({ name }) });
}

export async function deleteShareFolder(id: string): Promise<void> {
  await api(`/api/share-folders/${id}`, { method: 'DELETE' });
}
